import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '../skeleton/skeleton.component';

/** Loading placeholder shaped like an offering/focus card. */
@Component({
  selector: 'inexp-card-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './card-skeleton.component.html',
  styleUrl: './card-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-hidden': 'true' },
})
export class CardSkeletonComponent {}
